import { useState } from "react";
import { IAddress } from "../../models/Address/Address";
import { Combobox } from "@headlessui/react";
import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import clsx from "clsx";
import { ICustomerAddress } from "../../models/Customer/Customer";
import { FormTextField } from "../base/Form/FormTextField";
import { Button } from "../base/Button";
import { useFormContext } from "react-hook-form";
import { FormSelect } from "../base/Form/FormSelect";
import LoadingWheel from "./LoadingWheel";

interface AddressSearchComboboxProps {
  setValue: (value: ICustomerAddress) => void;
}

export function AddressSearchCombobox({
  setValue,
}: AddressSearchComboboxProps) {
  const { get } = useApiHelper();
  const [addresses, setAddresses] = useState<IAddress[]>([]);
  const [query, setQuery] = useState<string>();
  const [fetching, setFetching] = useState<boolean>(false);
  const [showSelect, setShowSelect] = useState<boolean>(false);

  const handleSelect = (index: string) => {
    setValue(addresses[parseInt(index)]);
  };

  const findAddresses = async () => {
    if (query && query.length > 5) {
      setFetching(true);
      setShowSelect(true);

      const res = await get<IDefaultResponse<IAddress[]>>(
        `/utilities/address/${query}`,
      );

      setAddresses(res.data);
      setFetching(false);
    }
  };

  return (
    <>
      <div className="flex flex-col space-y-1">
        <label className="text-sm font-medium opacity-80">Address Lookup</label>
        <div className="grid grid-cols-6 gap-2">
          <FormTextField
            containerClassName="col-span-5"
            name="__postcodeQuery"
            onChange={(e) => setQuery(e.currentTarget.value)}
          />
          <Button onClick={findAddresses}>Search</Button>
        </div>
      </div>
      {showSelect && (
        <div>
          <FormSelect
            label="Choose Address"
            name="__addressSelect"
            onChange={(e) => handleSelect(e.currentTarget.value)}
          >
            {fetching ? (
              <LoadingWheel />
            ) : addresses.length > 0 ? (
              addresses.map((address, i) => (
                <option key={i} value={i}>
                  {address.formatted.join(", ")}
                </option>
              ))
            ) : (
              <option disabled>No Addresses found</option>
            )}
          </FormSelect>
        </div>
      )}
    </>
  );
}
